//
//
//
//
//

export default {
  name: 'baseView',
  data () {
    return {}
  },
  watch: {},
  components: {}
}



// WEBPACK FOOTER //
// ./src/components/Base.vue